import React, { useEffect, useRef, useState } from 'react';
import './action-items-v2.styles.scss';
import { Link, Route, Routes, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faFilter, faRefresh, faShoppingBag } from '@fortawesome/free-solid-svg-icons';
import Modal from '@/components/modal/modal.component';
import ActivityFiltersV2 from '@/components/SHARED/detailed-activity-list/activity-filters-v2.component';
import ActionItemsListTable from './action-items-list-table.components';
import { getActivityRecordsQuery } from '@/utils/getDataFromDb';
import { useSelector } from 'react-redux';
import ViewActionItem from './view-action-item.component';
import RealworldListTable from '../action-items-realworld/action-realworld-list-table.component';
import { previewCompleteActionItems } from '@/components/PREVIEW/previewGameActionItems';

const ActionItemsV2 = ({
  gameData,
  gameStats,
  gameElements,
  playerList,
  pendingActionItems,
  changeActionItemStatus
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const [actionItemsToDisplay, setActionItemsToDisplay] = useState([]);
  const [queryFilter, setQueryFilter] = useState([]);
  const [noMore, setNoMore] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [resetFilter, setResetFilter] = useState(false);
  // const [ view, setView ] = useState('pending');
  const [moreLimit, setMoreLimit] = useState(10);
  const [actionItemToView, setActionItemToView] = useState(null);
  const [pendingCount, setPendingCount] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const [noApplicableElements, setNoApplicableElements] = useState([]);
  const view = searchParams.get('v');
  const completedActionItemsRef = useRef({});
  const scrollRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!gameData) return;
    const pageTitleEl = document.getElementById('page-title');
    if (pageTitleEl) {
      pageTitleEl.innerText =
        location.pathname.includes('actionitems')
          ? 'Manage Action Items'
          : location.pathname.includes('realworlddist')
            ? 'Real World Item Distribution'
            : '';
    }
  }, [gameData])

  useEffect(() => {
    if (!view || !gameElements || !playerList) return;
    setActionItemsToDisplay([]);
    displayActionItems(false, true);
    setNoMore(false);
    let noApplicable = []
    if (Object.values(gameElements).some(el =>
      el.type === 'quest' || el.type === 'challenge' || (
        el.type === 'item' && el.opt_itemType === 'inventory'
      )
    ) === false) {
      noApplicable.push('actionItems');
      setNoApplicableElements(noApplicable);
    }
    if (Object.values(gameElements).some(el =>
      el.opt_itemType === 'realworld'
    ) === false) {
      noApplicable.push('realworld');
      setNoApplicableElements(noApplicable);
    }
  }, [view, pendingActionItems, location, gameElements, playerList])

  useEffect(() => {
    if (!searchParams) return;
    const newView = searchParams.get('v');
    if (
      !newView && !location.pathname.includes('dist/') &&
      !location.pathname.includes('items/')
    ) {
      navigate(location.pathname + '?v=pending');
    }
  }, [searchParams])

  useEffect(() => {
    // if (!queryFilter) return;
    // if (queryFilter.length === 0) {
    let condition = '!='
    if (location.pathname.includes('/realworlddist')) {
      condition = '=='
    }
    setQueryFilter([{
      'key': 'type',
      'condition': condition,
      'value': 'realworld'
    }]);
    // }
  }, [location])

  function displayActionItems(next, clearRef) {
    setActionItemsToDisplay([]);
    console.log('displaying action items', view);
    if (clearRef) {
      completedActionItemsRef.current = {};
    }
    if (view === 'pending') {
      console.log(pendingActionItems);
      console.log(queryFilter);
      if (
        pendingActionItems &&
        queryFilter.filter(f => f.key !== 'status' && f.key !== 'type').length === 0
      ) {
        console.log('pending - no query');
        let filteredByType = Object.values(pendingActionItems)
          .filter(item =>
            (
              (item.type === 'checkpoint' && gameElements[item.questId]) ||
              gameElements[item.elementId]
            ) &&
            playerList[item.playerId])
          .filter(item => item.type !== 'realworld');
        if (location.pathname.includes('/realworlddist')) {
          filteredByType = Object.values(pendingActionItems)
            .filter(item =>
              (
                (item.type === 'checkpoint' && gameElements[item.questId]) ||
                gameElements[item.elementId]
              ) &&
              playerList[item.playerId])
            .filter(item => item.type === 'realworld')
        }
        console.log('filteredByType', filteredByType);
        setActionItemsToDisplay(filteredByType);
        setPendingCount(filteredByType.length);
      } else if (
        pendingActionItems &&
        queryFilter.filter(f => f.key !== 'status' && f.key !== 'type').length > 0
      ) {
        console.log('pending - has query');
        console.log(queryFilter);
        let filtered = [];
        let arr = Object.values(pendingActionItems);
        filtered = arr.filter(item => {
          let approve = true;
          for (let filter of queryFilter) {
            const key = filter.key;
            const condition = filter.condition;
            const value = filter.value;

            if (key === 'startDate') {
              if (item.ts < value) approve = false;
            }
            if (key === 'endDate') {
              if (item.ts > value) approve = false;
            }
            if (!condition || condition === '==') {
              if (item[key] !== value) approve = false;
            } else if (condition === '!=') {
              if (item[key] === value) approve = false;
            }
          }
          return approve;
        })
        setActionItemsToDisplay([...filtered]);

      } else {
        console.log('pending - no saved items');
        setActionItemsToDisplay([]);
      }
      setNoMore(true);
    } else {
      if (
        Object.values(completedActionItemsRef.current).length === 0 ||
        next
      ) {
        console.log('completed - next or existing completed items');
        getCompletedActionItems(next);
      } else {
        setActionItemsToDisplay(Object.values(completedActionItemsRef.current));
      }
    }
  }

  function getCompletedActionItems(next) {
    if (location.pathname.includes('/preview/manager/')) {
      console.log(queryFilter);
      // apply queryFilter objs to previewCompleteActionItems
      let filtered = Object.values(previewCompleteActionItems);
      if (queryFilter.filter(f => f.key !== 'status' && f.key !== 'type').length > 0) {
        filtered = filtered.filter(item => {
          let approve = true;
          for (let filter of queryFilter) {
            const key = filter.key;
            const condition = filter.condition;
            const value = filter.value;
            if (key === 'startDate') {
              if (item.ts < value) approve = false;
            }
            if (key === 'endDate') {
              if (item.ts > value) approve = false;
            }
            if (!condition || condition === '==') {
              if (item[key] !== value) approve = false;
            } else if (condition === '!=') {
              if (item[key] === value) approve = false;
            }
          } return approve;
        }
        )
      }
      completedActionItemsRef.current = { ...filtered };
      setActionItemsToDisplay(Object.values(filtered));
      return;
    }

    console.log('getting completed action items');
    if (queryFilter.filter(q => q.key === 'status').length === 0) {
      queryFilter.push(
        {
          'key': 'status',
          'condition': 'in',
          'value': ['approved', 'declined']
        }
      )
    }
    console.log(queryFilter);
    const queryObject = {
      'gameId': gameData.gameId,
      'path': 'actionItems',
      'filter': queryFilter,
      'limit': moreLimit,
      'once': true,
      'callback': callback
    }
    if (next) {
      const len = Object.keys(completedActionItemsRef.current).length
      queryObject.lastEntry = Object.values(completedActionItemsRef.current)
        .sort((a, b) => a.ts < b.ts ? 1 : -1)[len - 1];
    }
    //   // Handle 'next' filter
    getActivityRecordsQuery(queryObject)
    // }

    function callback(data) {
      console.log(data);
      if (next) {
        completedActionItemsRef.current = {
          ...completedActionItemsRef.current,
          ...data
        };
      } else {
        completedActionItemsRef.current = { ...data };
      }
      console.log(data);
      if (Object.keys(data).length < moreLimit) {
        setNoMore(true);
      } else {
        setNoMore(false);
      }
      setActionItemsToDisplay(Object.values(completedActionItemsRef.current));
    }
  }

  function nextPage() {
    displayActionItems(true);
    const timeout = setTimeout(() => {
      if (screenSize === 'mobile') {
        scrollRef.current = document.querySelector('.action-items-list-table').scrollTop;
      } else {
        scrollRef.current = document.querySelector('#scroll-to-top').scrollTop;
      }
      clearTimeout(timeout);
    }, 200)
  }

  function goToTransaction(actionItem) {
    setActionItemToView(actionItem);
    navigate(`${location.pathname.includes('/preview/manager/')
      ? `/preview/manager`
      : `/manage`
      }/${gameData.path}/actionitems/${actionItem.path}`);
  }

  return (
    <div className={`action-items-v2 ${screenSize}`}>
      <Routes>
        <Route path='' element={
          <div className='action-items-content g-card'>
            <BackButton cancel={() =>
              location.pathname.includes('/preview/manager/')
                ? navigate(`/preview/manager/${gameData.path}`)
                : navigate(`/manage/${gameData.path}`)} />
            <div className='g-space-1'></div>

            {
              (location.pathname.includes('actionitems'))
                ?
                <div className='card-title'>
                  <FontAwesomeIcon icon={faBell} />
                  Action Items
                </div>
                :
                (location.pathname.includes('realworlddist')) ?
                  <div className='card-title'>
                    <FontAwesomeIcon icon={faShoppingBag} />
                    Real World Distribution
                  </div>
                  :
                  null
            }

            <hr />
            <div className='filter-row buttons'>
              {
                (view === 'pending')
                  ?
                  <h3>
                    Pending: {pendingCount}
                  </h3>
                  :
                  <h3>Completed</h3>
              }
              <div className='buttons'>
                <button
                  className='g-button small-btn'
                  onClick={() => navigate(location.pathname + '?v=' + (view === 'pending' ? 'completed' : 'pending'))}
                >
                  Switch to {view === 'pending' ? 'Completed' : 'Pending'}
                  <FontAwesomeIcon icon={faRefresh} />
                </button>
                <button
                  className='g-button small-btn'
                  onClick={() => setShowFilterModal(true)} >
                  Filter
                  <FontAwesomeIcon
                    className={
                      queryFilter
                        ?.filter(q => q.key !== 'type' && q.key !== 'status')
                        .length > 0 ? 'active' : 'inactive'}
                    icon={faFilter} />
                </button>
              </div>
            </div>
            <div className="g-space-1"></div>
            {
              (
                noApplicableElements &&
                (
                  (
                    location.pathname.includes('/actionitems') &&
                    noApplicableElements.includes('actionItems')
                  ) ||
                  (
                    location.pathname.includes('/realworlddist') &&
                    noApplicableElements.includes('realworld')
                  )
                )
              ) ?
                <div className='no-applicable-elements g-card'>
                  <h3>Create Some Elements to Get Started!</h3>
                  {
                    (location.pathname.includes('/actionitems')) ?
                      <>
                        <p>Action items are automatically generated when players interact with certain game elements, such as quests, challenges, or inventory items. Since your game currently doesn't have any of these types of elements, there are no action items to display.</p>
                        <p>To start seeing action items here, try adding quests, challenges, or inventory items to your game and encourage players to interact with them!</p>
                      </>
                      :
                      <>
                        <p>Real world item distribution action items are generated when players purchase or earn items that have the "realworld" option enabled. Since your game currently doesn't have any items with this option, there are no real world distribution action items to display.</p>
                        <p>To start seeing real world distribution action items here, try adding some items with the "realworld" option enabled to your game.</p>
                      </>
                  }
                  <div className='center-col'>
                    <Link to={`/manage/${gameData.path}/elements`}>
                      <button
                        className='g-button'>
                        Get Started!
                      </button>
                    </Link>
                  </div>
                </div>
                :
                (location) &&
                  (location.pathname.includes('actionitems'))
                  ?
                  <ActionItemsListTable
                    gameData={gameData}
                    actionItemsToDisplay={actionItemsToDisplay}
                    playerList={playerList}
                    gameElements={gameElements}
                    manager={true}
                    gameManagers={[]}
                    goToTransaction={goToTransaction}
                    view={view}
                  />
                  :
                  (location.pathname.includes('realworlddist'))
                    ?
                    <RealworldListTable
                      gameData={gameData}
                      actionItemsToDisplay={actionItemsToDisplay}
                      playerList={playerList}
                      gameElements={gameElements}
                      manager={true}
                      gameManagers={[]}
                      goToTransaction={goToTransaction}
                      view={view}
                      changeActionItemStatus={changeActionItemStatus}
                    />
                    :
                    null
            }
            {
              (
                view === 'completed' &&
                !location.pathname.includes('/preview/manager/')
              ) &&
              <>
                <div className="g-space-1"></div>
                <div className='center-col'>
                  <button
                    className={`g-button small-btn ${noMore ? 'disabled' : ''}`}
                    onClick={() => nextPage()}>
                    Load More...
                  </button>
                </div>
              </>
            }
          </div>
        }></Route>
        <Route
          path=':itemPath'
          element={
            <ViewActionItem
              gameData={gameData}
              gameStats={gameStats}
              gameElements={gameElements}
              playerList={playerList}
              actionItems={pendingActionItems}
              changeActionItemStatus={changeActionItemStatus}
              actionItemToView={actionItemToView}
            />
          }
        ></Route>
      </Routes>
      <Modal
        show={showFilterModal}
        cancel={() => setShowFilterModal(false)}
        text="Filter Activity Records"
        closeButton={true}
        cls="narrow" >
        <div className='filter-modal-content'>
          <ActivityFiltersV2
            gameData={gameData}
            gameManagers={[]}
            playerList={playerList}
            gameElements={gameElements}
            queryFilter={queryFilter}
            setQueryFilter={setQueryFilter}
            resetFilter={resetFilter}
            setResetFilter={setResetFilter} />
          <hr />
          <div className='buttons'>
            <button
              className='g-button med-btn'
              onClick={() => setResetFilter(true)}>
              Clear Filters
            </button>
            <button
              className='g-button med-btn primary'
              onClick={() => {
                setShowFilterModal(false);
                displayActionItems(false, true)
              }}>
              Apply Filters
            </button>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default ActionItemsV2